import {useState} from "react";
import type {LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";
import type {DirectionalLight} from "@/dungeons/lighting/DirectionalLight.ts";
import type {GeometryDocumentUpdate} from "../shared/useLevelGeometryDocument.ts";

export default function useLevelLighting({document, updateDocument}: {
    document: LevelGeometryDocument;
    updateDocument: (update: GeometryDocumentUpdate) => void;
}) {
    const [preview, setPreview] = useState<{base: DirectionalLight; light: DirectionalLight}>();
    const light = preview?.base === document.directionalLight ? preview.light : document.directionalLight;
    const commit = (next: DirectionalLight) => {
        setPreview(undefined);
        updateDocument(current => Object.keys(next).every(key => next[key as keyof DirectionalLight]
            === current.directionalLight[key as keyof DirectionalLight]) ? current : {...current, directionalLight: next});
    };
    return {light, commit, preview: (next: DirectionalLight) => setPreview({base: document.directionalLight, light: next})};
}
